import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';

function NewComponent() {
    const navigate = useNavigate();
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, m: '2.5rem' }}
    >
      <Typography variant="h6">New</Typography>
      <Box sx={{ display: 'flex', gap: 2, px: '2rem' }}>
        <Box
          sx={{
            width: '10rem',
            height: '12rem',
            bgcolor: 'background.default',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            border: '0.6px solid #ccc',
            boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.15)',
          }}
          onClick={() => {
              navigate('/workflow');
          }}
        >
          <IconButton>
            <AddIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}

export default NewComponent;
